// Auto-merges every dictionary file under ./dict into one translations table.
// Each dict file exports `{ en: {...}, ru: {...}, geo: {...} }` with flat, namespaced
// keys (e.g. "booking.vin"). Drop a new file in ./dict and it is picked up automatically.
const ctx = require.context("./dict", false, /\.js$/);

const translations = { en: {}, ru: {}, geo: {} };

ctx.keys().forEach((key) => {
    const mod = ctx(key).default;
    if (!mod) return;
    ["en", "ru", "geo"].forEach((lang) => {
        if (mod[lang]) Object.assign(translations[lang], mod[lang]);
    });
});

export { translations };

export function translate(lang, key) {
    const table = translations[lang] || translations.en;
    if (table && table[key] != null) return table[key];
    if (translations.en[key] != null) return translations.en[key];
    return key;
}
